import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-full animate-spin" style={{ border: '3px solid #14b8a6', borderTopColor: 'transparent' }} />
        <p className="text-gray-500 text-sm">Loading...</p>
      </div>
    </div>
  );
}
